/**
 * 修改排序号
 * @author pengwen
 * @date 2023-06-30
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, component_tool, utils_tool } from '@/tool';
let { WizModal, WizComponent, WizForm, WizCheckbox, WizRow, WizCol,WizSpin,WizButton,WizInputNumber } = component_tool;
let { WizContainer, WizReduxTemplate,modelUtils } = framework_tool;
let { Session } = utils_tool

class UpdateSort extends WizContainer {

    componentName = 'UpdateSort';

    constructor(props) {
        super(props)
        let { record } = props
        this.state = {
            record,
            sort : record.sort,
            timestamp: new Date().getTime(),
            proKnowledgeTypeTitle: record.proKnowledgeTypeTitle,
            title: title
        }
        this.initialValue = record
    }

    _componentDidMount() {

    }

    propsAndStateOnChange = {
        checkTypeAndSort: this._checkTypeAndSort.bind(this),
        checkTypeAndSortFinal: this._checkTypeAndSortFinal.bind(this)
    };

    _checkTypeAndSort(nextProps, nextState) {
        if (nextProps.checkTypeAndSort.code === 1) {
          wizNotice.success('保存成功');
          nextProps.changeModal(false,true);
        } else {
            const content = '同知识类型下已存在此排序号，是否确认？'
            console.log("content==",content)
            WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                    console.log("ok")
                    this._onCheckFinal()
                },
                onCancel : () => {
                    this.props.changeModal(false)
                }
            })

        }
    }
    
    _onCheck = () => {
        let { record, sort } = this.state
        if (!sort) {
            wizNotice.warn('排序号不能为空');
            return;
        }
        const {id,proKnowledgeTypeId} = record
        this.doAction({
            path: 'proKnowledge/checkTypeAndSort',
            payload: {
              key: 'checkTypeAndSort',
              apiParams: {
                id,proKnowledgeTypeId,sort
              }
            }
        })            
          
    }

    _checkTypeAndSortFinal(nextProps, nextState) {
        if (nextProps.checkTypeAndSortFinal.code === 1) {
            wizNotice.success('保存成功');
            nextProps.changeModal(false,true);
        } else {
            wizNotice.error(nextProps.checkTypeAndSort.msg)
        }
    }

    _onCheckFinal = () => {
        let { record, sort } = this.state
        if (!sort) {
            wizNotice.warn('排序号不能为空');
            return;
        }
        const {id,proKnowledgeTypeId} = record
        this.doAction({
            path: 'proKnowledge/checkTypeAndSort',
            payload: {
              key: 'checkTypeAndSortFinal',
              apiParams: {
                id,proKnowledgeTypeId,sort,sortFlag: 1
              }
            }
        }) 
    }

    _info() {
        return <div className="menu-item">
            <WizRow className="look-row" >
                <WizCol offset={2} span={4} style={{ }}>知识类型：</WizCol>
                <WizCol span={18}>
                    {this.initialValue.proKnowledgeTypeTitle}
                </WizCol>
            </WizRow>
            <WizRow className="look-row" >
                <WizCol offset={2} span={4} style={{  }}>标题：</WizCol>
                <WizCol span={18}>
                    {this.initialValue.title}
                </WizCol>
            </WizRow>
            <WizRow className="look-row" >
                <WizCol offset={1} span={1} ><font style={{color:'red', verticalAlign: 'middle' }}>*</font></WizCol>
                <WizCol span={4} >排序号：</WizCol>
                <WizCol span={18}>
                    <WizInputNumber min={1} max={99999999} precision={0} size='middle' defaultValue={this.initialValue.sort} placeholder="排序号"
                        onChange={(value) => {
                            this.setState({ sort: value })
                        }}                   
                    />
                </WizCol>
            </WizRow>
            <WizRow className='audit-submit-button-row'>
                <WizCol>
                    <WizButton title='取消' onClick={() => { this.setState({ timestamp: new Date().getTime() }); this.props.changeModal(false) }}>取消</WizButton>
                    <WizButton title='确认' type='primary' onClick={() => this._onCheck()}>确认</WizButton>
                </WizCol>
            </WizRow>
        </div>
    }

    render() {
        let { record, timestamp } = this.state
        return <div className="updateSort" key={timestamp}>
            {this._info()}
        </div>
    }
}




const mapStateToProps = (state, ownProps) => {
    const { proKnowledge } = state;
    const checkTypeAndSort = modelUtils.getModelEntity(proKnowledge, 'checkTypeAndSort');
    const checkTypeAndSortFinal = modelUtils.getModelEntity(proKnowledge,'checkTypeAndSortFinal');
    return {
        checkTypeAndSort,
        checkTypeAndSortFinal
    };
};

export default connect(mapStateToProps)(UpdateSort);